// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"271eceaf","2803":"d7c41854","3585":"d7c41854","3768":"be16120f","5380":"271eceaf","8886":"eeb7014c"}[chunkId] + ".chunk.css";
};